export default "__VITE_ASSET__8FU1h7fI__"